import React from "react";
import { View, Text, TouchableOpacity, Image } from "react-native";
import { BoldText } from "components/markdown-text";

import { styles } from "./styles";

export const Icon = ({ text, onPress, image, isSelected }) => {
  return (
    <View style={[styles.container]}>
      <TouchableOpacity onPress={onPress}>
        <Image
          source={{ uri: image || null }}
          resizeMode="contain"
          style={[styles.icon, isSelected && styles.iconSelected]}
        />
        <Text style={[styles.label, isSelected && styles.labelSelected]}>
          <BoldText>{text}</BoldText>
        </Text>
      </TouchableOpacity>
    </View>
  );
};
